<div class="bloco">
  <app-alert-card type="info" title="Controle de estoque" icon="inventory_2">{{ descricaoControle }}</app-alert-card>

  <app-estoque-lote-serie-inline
    [tipo]="tipo"
    modo="selecionar"
    [quantidadeAlvo]="quantidadeAlvo"
    [isFracionada]="isUnidadeMedidaFracionada"
    [contexto]="nomeLocalizacaoEstoque"
    [idProduto]="idProduto ?? undefined"
    [idLocalizacaoEstoque]="idLocalizacaoEstoque ?? undefined"
    [isSomenteLeitura]="isSomenteLeitura"
    [disponiveis]="disponiveis"
    [itens]="itensSelecionados"
    [(aberto)]="painelAberto"
    (itensChange)="aoAlterarSelecao($any($event))">
  </app-estoque-lote-serie-inline>
</div>
